var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSodarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4146 2V1H7V2H12.4146ZM13.0915 3.0914V4.0914H7V3.0914H13.0915ZM14.4451 6.18281V5.18281H7V6.18281H14.4451ZM15.7988 7.27421V8.27421H7V7.27421H15.7988ZM16.4756 10.3656V9.36562H7V10.3656H16.4756ZM17.5772 11.457V12.457H7V11.457H17.5772ZM7.01909 13.4278H18.8382C18.8382 13.4278 19.9311 19.3722 13.6409 20.8994C13.611 20.9066 13.6086 21.0391 13.6048 21.2505C13.5928 21.9101 13.5668 23.3387 12.649 24.1378C11.1588 25.4352 8.19601 25.4906 7.01909 22.7457C6.98091 22.6566 7.01909 13.4278 7.01909 13.4278Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodarWhite);
export default __webpack_public_path__ + "static/media/sodar-white.62befe2a.svg";
export { ForwardRef as ReactComponent };